import React from 'react';
import CControl from '../types/CControl';
import { IPFieldProps } from '../../types/field-props';

export const UXHorizontalLine = (props: IPFieldProps<CControl>): JSX.Element => {
    return <hr />
}